import React from "react";
import { Create, SimpleForm, TextInput } from "react-admin";

export const AutoInsuranceCompanyCreate = props => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <TextInput source="name" autoFocus />
    </SimpleForm>
  </Create>
);
